<template>
    <div class="select-btn-box">
        <div class="btn-box" :class="selected === false ? 'default-box' : 'selected-box'">
            <span><slot /></span>
        </div>
    </div>
</template>

<script setup>
    import {onMounted} from "vue";

    const props = defineProps(["selected"])

    onMounted(() => {

    })
</script>

<style scoped>
    .select-btn-box {
        /*width: 25%;*/
        box-sizing: border-box;
        padding: 10px;
        display: inline-block;
    }

    @media screen and (min-width: 520px) {
        .select-btn-box .btn-box {
            width: 100%;
            box-sizing: border-box;
            padding: 10px;
            font-size: 18px;
            font-weight: 600;
            border: 1px #E4E7ED solid;
            border-radius: 5px;
            cursor: pointer;
        }
    }

    @media screen and (max-width: 520px) {
        .select-btn-box .btn-box {
            width: 100%;
            box-sizing: border-box;
            padding: 10px;
            font-size: 12px;
            font-weight: 600;
            border: 1px #E4E7ED solid;
            border-radius: 5px;
            cursor: pointer;
        }
    }

    .select-btn-box .btn-box:hover {
        color: #fefefe;
        background: #409EFF;
    }

    .selected-box {
        color: #fefefe;
        background: #409EFF;
    }

    .default-box {
        color: #606266;
        background: #FFFFFF;
    }
</style>